import { render, staticRenderFns } from "./SMSTemplateList.vue?vue&type=template&id=74432fdc&scoped=true&"
import script from "./SMSTemplateList.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./SMSTemplateList.vue?vue&type=style&index=0&id=74432fdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74432fdc",
  null
  
)

export default component.exports